import React, { useState } from 'react';
import ReactDom from 'react-dom';
import LogoSmall from '../../assets/img/logo.png';
import Logo from '../../assets/img/logo3.png';
import {Link} from 'react-router-dom';
import styles from './Header.module.css';
import Container from '@mui/material/Container';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import HeaderMenu from './HeaderMenu';
import ModalBackground from '../UI/ModalBackground';
import HeaderMobileMenu from './HeaderMobileMenu';



const Header = () => {
    const [menuIconClick, setMenuIconClick] = useState(false);

    const [expandedId, setExpandedId] = useState(null);

    const expandedIdHanlder = (index) => {
        setExpandedId(() => index);
    }

    const menuIconClickHandler = () => {
        setMenuIconClick( () => !menuIconClick);
    }
    const modalClickHandler = () => {
        setMenuIconClick( () => !menuIconClick);
    }

    return (
        <header className={styles.header}>
            {/* 모바일 메뉴 관련 컴포넌트  */}
            {menuIconClick ? 
                ReactDom.createPortal(<ModalBackground onClick={modalClickHandler}/>, document.getElementById('backdrop-root'))
                : null
            }
            {menuIconClick ? 
                ReactDom.createPortal(
                    <HeaderMobileMenu 
                        on={modalClickHandler} 
                        expandedId={expandedId} 
                        expandedHanlder={expandedIdHanlder} 
                    />, document.getElementById('modal-root'))
                : null
            }
            
            <Container 
                component="nav"
                maxWidth="lg" 
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0 20px",
                    height: "70px"
                    }} >
                <div>
                    <Link to="/"><img src={Logo} alt="logo" className={styles.logo}/></Link>
                    <Link to="/"><img src={LogoSmall} alt="logo_small" className={styles.logo_small}/></Link>
                </div>
                <HeaderMenu iconClick={menuIconClick}/>

                <div className={styles.menuIconArea}>
                    <MenuRoundedIcon fontSize="large" className={styles.menuIcon} onClick={menuIconClickHandler}/>
                </div>
            </Container>
        </header>
    )
}

export default Header;